import {CardView} from '../../ui_canvas_engine/CardView'
import {BaseCardData} from '@colonist/game-card-types'
import {CardEnum, CardTypeEnum} from '@colonist/game-states'
import {ArrayUtils} from '@colonist/utils'

export class UIGameCardViewInventory {
    cardViews: CardView[]

    constructor() {
        this.cardViews = []
    }

    addCardView(cardView: CardView) {
        this.cardViews.push(cardView)
        this.sortCardViews()
    }

    sortCardViews() {
        this.cardViews.sort((a, b) => {
            if(a.cardData.cardEnum > b.cardData.cardEnum) return 1
            if(a.cardData.cardEnum == b.cardData.cardEnum) return 0
            return -1
        })
    }

    getCardTypeCount(cardEnum: CardEnum): number {
        let count = 0
        for(const card of this.cardViews) {
            if(card.cardData.cardEnum != cardEnum) continue
            count += 1
        }
        return count
    }

    getTopCardWithType(cardEnum: CardEnum): CardView | undefined {
        for(let index = this.cardViews.length - 1; index >= 0; index -= 1) {
            const cardView = this.cardViews[index]
            if(cardView.cardData.cardEnum == cardEnum) return cardView
        }
        return undefined
    }

    getAmountOfDifferentTypes(): number {
        const types: CardEnum[] = []
        for(const card of this.cardViews) {
            if(types.indexOf(card.cardData.cardEnum) > -1) continue
            types.push(card.cardData.cardEnum)
        }
        return types.length
    }

    hasCardOfType(cardEnum: CardEnum): boolean {
        for(const card of this.cardViews) {
            if(card.cardData.cardEnum == cardEnum) return true
        }
        return false
    }

    getAllCardEnums(): CardEnum[] {
        const cards: CardEnum[] = []
        for(const cardView of this.cardViews) {
            cards.push(cardView.cardData.cardEnum)
        }
        return cards
    }

    getAllCardViewsOfType(cardEnum: CardEnum): CardView[] {
        return this.cardViews.filter((cardView) => cardView.cardData.cardEnum == cardEnum)
    }

    hideCardBadges() {
        for(const cardView of this.cardViews) {
            cardView.hideBadge()
        }
    }

    showCardBadges() {
        for(const cardView of this.cardViews) {
            cardView.showBadge()
        }
    }

    static getPartitionCardIndexes(cardsData: BaseCardData[]): number[] {
        const cardTypeWhichShouldCreateAPartition = [CardTypeEnum.AnyResource, CardTypeEnum.Development]
        const cardTypeArray = cardsData.map((cardData) => cardData.cardTypeEnum)

        const partitionIndexes: Set<number> = new Set()
        for(const cardType of cardTypeWhichShouldCreateAPartition) {
            const index = ArrayUtils.findIndexGreaterThanOrEqual(cardTypeArray, cardType)
            if(index == -1) continue
            partitionIndexes.add(index)
        }

        return Array.from(partitionIndexes)
    }
}
